import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NudgesService } from '../../global-services/nudges.service';
import { AMPLITUDE_EVENT_CATEGORIES, AMPLITUDE_EVENTS, AmplitudeService } from '../../global-services/amplitude.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-download-cards-app-mobile-nudge',
    templateUrl: './download-cards-app-mobile-nudge.component.html',
    styleUrls: ['./download-cards-app-mobile-nudge.component.scss'],
    standalone: false
})
export class DownloadCardsAppMobileNudgeComponent implements OnInit {
  
  @Output() bannerClosed = new EventEmitter<void>();
  
  appStoreUrl = environment.appStoreUrl;
  playStoreUrl = environment.playStoreUrl;
  
  showBanner: boolean = false; // Don't show by default
  downloadButtonText: string = 'Download Now'; // Default text
  deviceOs: string;

  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private readonly nudgesService: NudgesService, 
    private readonly amplitudeService: AmplitudeService,
    private readonly deviceDetectorService: DeviceDetectorService
  ) {}

  ngOnInit() {
    this.deviceOs = this.deviceDetectorService.getDeviceInfo().os;
    this.checkIfShouldShowBanner();
    
    // Subscribe to service to control bottom nudge visibility
    this.nudgesService.bottomNudgeVisible$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((visible) => {
      this.showBanner = visible;
    });
  }

  onCloseBanner(): void {
    this.showBanner = false;
    // Notify service that bottom nudge was dismissed - topbar nudge can now show
    this.nudgesService.dismissBottomNudge();
    // Emit event to parent component
    this.bannerClosed.emit();
    this.amplitudeService.logEvent(AMPLITUDE_EVENT_CATEGORIES.Usage, AMPLITUDE_EVENTS.MOBILE_APP_MODAL_DISMISSED, {
      triggered_from: 'bottom',
      application: 'PWA',
      launch_modal: true,
    });
  }

  onDownloadApp(): void {
    this.amplitudeService.logEvent(AMPLITUDE_EVENT_CATEGORIES.Usage, AMPLITUDE_EVENTS.MOBILE_APP_NUDGE_ACTION_CLICKED, {
      triggered_from: 'bottom',
      application: 'PWA',
      cta: 'download_app',
    });
    
    if (this.deviceOs === 'Android') {
      window.open(this.playStoreUrl, '_blank');
    } else if (this.deviceOs === 'iOS') {
      window.open(this.appStoreUrl, '_blank');
    }
  }

  private checkIfShouldShowBanner(): void {
    // Only show on mobile devices
    if (!this.deviceDetectorService.isMobile()) {
      this.showBanner = false;
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
} 